export interface DeviceRecord {
  id: string;
  name: string;
  sku: string;
  category: string;
  salePrice: number;
  rentalPrice: number;
  stock: number;
  icon: string;
}

export interface PackageRecord {
  id: string;
  name: string;
  deviceIds: string[];
  discount: number;
}

export interface PlanRecord {
  id: string;
  name: string;
  category: string;
  description: string;
  packageIds: string[];
}

export interface SceneRecord {
  id: string;
  name: string;
  category: string;
  description: string;
  status: '启用' | '草稿' | '停用';
}

export const devices: DeviceRecord[] = [
  {
    id: 'DEV-001',
    name: 'Sony ZV-E10 II',
    sku: 'SKU-相0001',
    category: '摄像机',
    salePrice: 5700,
    rentalPrice: 285,
    stock: 1,
    icon: '📷',
  },
  {
    id: 'DEV-002',
    name: 'Sony A7M4',
    sku: 'SKU-相0002',
    category: '摄像机',
    salePrice: 3950,
    rentalPrice: 198,
    stock: 19,
    icon: '📷',
  },
  {
    id: 'DEV-003',
    name: '松下 GH6',
    sku: 'SKU-相0003',
    category: '摄像机',
    salePrice: 500,
    rentalPrice: 25,
    stock: 23,
    icon: '📹',
  },
  {
    id: 'DEV-004',
    name: '大疆 Pocket 3',
    sku: 'SKU-相0004',
    category: '摄像机',
    salePrice: 8700,
    rentalPrice: 435,
    stock: 15,
    icon: '🎥',
  },
  {
    id: 'DEV-005',
    name: '索尼 FX3',
    sku: 'SKU-相0005',
    category: '摄像机',
    salePrice: 18200,
    rentalPrice: 910,
    stock: 14,
    icon: '📷',
  },
  {
    id: 'DEV-006',
    name: '佳能 C70',
    sku: 'SKU-相0006',
    category: '摄像机',
    salePrice: 18000,
    rentalPrice: 900,
    stock: 9,
    icon: '🎦',
  },
  {
    id: 'DEV-007',
    name: 'Sony 16-35 PZ',
    sku: 'SKU-镜0007',
    category: '镜头',
    salePrice: 9600,
    rentalPrice: 480,
    stock: 3,
    icon: '🔭',
  },
  {
    id: 'DEV-008',
    name: 'Sony 24-70 GM II',
    sku: 'SKU-镜0008',
    category: '镜头',
    salePrice: 6100,
    rentalPrice: 305,
    stock: 39,
    icon: '🔭',
  },
  {
    id: 'DEV-009',
    name: '腾龙 28-75 G2',
    sku: 'SKU-镜0009',
    category: '镜头',
    salePrice: 11350,
    rentalPrice: 568,
    stock: 32,
    icon: '🔭',
  },
  {
    id: 'DEV-010',
    name: '小痰盂 50mm',
    sku: 'SKU-镜0010',
    category: '镜头',
    salePrice: 700,
    rentalPrice: 35,
    stock: 30,
    icon: '🔭',
  },
  {
    id: 'DEV-011',
    name: '爱图仕 300X',
    sku: 'SKU-灯0011',
    category: '灯光',
    salePrice: 11750,
    rentalPrice: 588,
    stock: 20,
    icon: '💡',
  },
  {
    id: 'DEV-012',
    name: '罗德 Wireless PRO',
    sku: 'SKU-音0012',
    category: '音频',
    salePrice: 3200,
    rentalPrice: 160,
    stock: 8,
    icon: '🎙️',
  },
  {
    id: 'DEV-013',
    name: 'ATEM Mini Pro ISO',
    sku: 'SKU-导0013',
    category: '导播',
    salePrice: 4680,
    rentalPrice: 234,
    stock: 0,
    icon: '🎛️',
  },
  {
    id: 'DEV-014',
    name: 'DJI RS 4 Pro',
    sku: 'SKU-稳0014',
    category: '稳定器',
    salePrice: 6299,
    rentalPrice: 315,
    stock: 2,
    icon: '🦾',
  },
  {
    id: 'DEV-015',
    name: '萨拿 Ace M 三脚架',
    sku: 'SKU-撑0015',
    category: '支撑',
    salePrice: 6800,
    rentalPrice: 340,
    stock: 35,
    icon: '🗼',
  },
  {
    id: 'DEV-016',
    name: 'Magewell 采集卡',
    sku: 'SKU-采0016',
    category: '采集',
    salePrice: 2899,
    rentalPrice: 145,
    stock: 4,
    icon: '🖥️',
  },
  {
    id: 'DEV-017',
    name: '4K 直播推流工作站',
    sku: 'SKU-机0017',
    category: '工作站',
    salePrice: 22800,
    rentalPrice: 1140,
    stock: 1,
    icon: '🧑‍💻',
  },
  {
    id: 'DEV-018',
    name: '5G 聚合路由器',
    sku: 'SKU-网0018',
    category: '网络',
    salePrice: 3999,
    rentalPrice: 200,
    stock: 0,
    icon: '📡',
  },
  {
    id: 'DEV-019',
    name: '舒尔 SM7B',
    sku: 'SKU-音0019',
    category: '音频',
    salePrice: 3299,
    rentalPrice: 165,
    stock: 11,
    icon: '🎤',
  },
  {
    id: 'DEV-020',
    name: '森海塞尔 MKE600',
    sku: 'SKU-音0020',
    category: '音频',
    salePrice: 2499,
    rentalPrice: 125,
    stock: 6,
    icon: '🎙️',
  },
  {
    id: 'DEV-021',
    name: '南光 Forza 60B II',
    sku: 'SKU-灯0021',
    category: '灯光',
    salePrice: 1599,
    rentalPrice: 80,
    stock: 28,
    icon: '🔦',
  },
  {
    id: 'DEV-022',
    name: '22 寸折叠提词器',
    sku: 'SKU-提0022',
    category: '提词器',
    salePrice: 1299,
    rentalPrice: 65,
    stock: 7,
    icon: '🪞',
  },
  {
    id: 'DEV-023',
    name: '7 寸导演监视器',
    sku: 'SKU-监0023',
    category: '监看',
    salePrice: 1899,
    rentalPrice: 95,
    stock: 13,
    icon: '📺',
  },
  {
    id: 'DEV-024',
    name: 'HDMI 2.1 光纤线 20m',
    sku: 'SKU-线0024',
    category: '配件',
    salePrice: 499,
    rentalPrice: 25,
    stock: 80,
    icon: '🔌',
  },
];

export const packages: PackageRecord[] = [
  {
    id: 'PKG-001',
    name: '竖屏单机直播套装',
    deviceIds: ['DEV-001', 'DEV-007', 'DEV-012'],
    discount: 98,
  },
  {
    id: 'PKG-002',
    name: '室内课程录制套装',
    deviceIds: ['DEV-002', 'DEV-008', 'DEV-011'],
    discount: 95,
  },
  {
    id: 'PKG-003',
    name: '双机访谈直播套装',
    deviceIds: ['DEV-003', 'DEV-006', 'DEV-012'],
    discount: 96,
  },
  {
    id: 'PKG-004',
    name: '户外活动直播套装',
    deviceIds: ['DEV-004', 'DEV-009'],
    discount: 97,
  },
  {
    id: 'PKG-005',
    name: '四机位导播套装',
    deviceIds: ['DEV-006', 'DEV-013', 'DEV-016', 'DEV-023'],
    discount: 93,
  },
  {
    id: 'PKG-006',
    name: '移动稳定拍摄套装',
    deviceIds: ['DEV-004', 'DEV-014', 'DEV-020'],
    discount: 96,
  },
  {
    id: 'PKG-007',
    name: '企业发布会推流套装',
    deviceIds: ['DEV-017', 'DEV-018', 'DEV-022', 'DEV-024'],
    discount: 92,
  },
  {
    id: 'PKG-008',
    name: '播客录音套装',
    deviceIds: ['DEV-019', 'DEV-020', 'DEV-021'],
    discount: 95,
  },
];

export const plans: PlanRecord[] = [
  {
    id: 'PLAN-001',
    name: '初创团队直播方案',
    category: '直播',
    description: '单机位、灯光、收音完整组合',
    packageIds: ['PKG-001', 'PKG-002'],
  },
  {
    id: 'PLAN-002',
    name: '品牌电商标准间',
    category: '直播',
    description: '适合稳定日播与访谈',
    packageIds: ['PKG-002', 'PKG-003'],
  },
  {
    id: 'PLAN-003',
    name: '户外活动直播方案',
    category: '活动',
    description: '轻量便携，适合快速搭建',
    packageIds: ['PKG-004'],
  },
  {
    id: 'PLAN-004',
    name: '新品发布会全案',
    category: '发布会',
    description: '四机位、导播、推流和提词完整链路',
    packageIds: ['PKG-005', 'PKG-007'],
  },
  {
    id: 'PLAN-005',
    name: '移动短视频拍摄方案',
    category: '短视频',
    description: '稳定器、收音和便携机位组合',
    packageIds: ['PKG-006'],
  },
  {
    id: 'PLAN-006',
    name: '企业播客录制方案',
    category: '播客',
    description: '双人访谈录音、补光与监听',
    packageIds: ['PKG-008'],
  },
];

export const scenes: SceneRecord[] = [
  {
    id: 'SC-01',
    name: '单机竖屏直播间',
    category: '直播',
    description: '低预算单主播场景',
    status: '启用',
  },
  {
    id: 'SC-02',
    name: '双机企业采访',
    category: '访谈',
    description: '主近景与嘉宾侧机位',
    status: '启用',
  },
  {
    id: 'SC-03',
    name: '户外活动直播',
    category: '活动',
    description: '弱网与移动供电场景',
    status: '启用',
  },
  {
    id: 'SC-04',
    name: '新品发布会',
    category: '发布会',
    description: '多机位导播与提词',
    status: '启用',
  },
  {
    id: 'SC-05',
    name: '在线课程录制',
    category: '教育',
    description: '讲师、课件和板书同步',
    status: '启用',
  },
  {
    id: 'SC-06',
    name: '双人播客',
    category: '播客',
    description: '双麦克风与氛围灯光',
    status: '草稿',
  },
  {
    id: 'SC-07',
    name: '绿幕虚拟演播室',
    category: '虚拟制作',
    description: '绿幕、追踪与实时合成',
    status: '停用',
  },
];

export const customers = [
  {
    customerNo: 'CUST-1026',
    name: '新锐电脑',
    contact: '黄磊',
    phone: '13811038623',
    owner: '吴恩帅',
  },
  {
    customerNo: 'CUST-1025',
    name: '悦动视觉',
    contact: '陈静',
    phone: '13847260428',
    owner: '王芳',
  },
  {
    customerNo: 'CUST-1024',
    name: '光合文化(深圳)',
    contact: '李娜',
    phone: '13821235525',
    owner: '刘洋',
  },
  {
    customerNo: 'CUST-1023',
    name: '星辉传媒',
    contact: '王芳',
    phone: '13863723541',
    owner: '刘经理',
  },
  {
    customerNo: 'CUST-1022',
    name: '海风教育科技',
    contact: '周老师',
    phone: '13922018862',
    owner: '陈静',
  },
  {
    customerNo: 'CUST-1021',
    name: '云图电商',
    contact: '赵鹏',
    phone: '13755190472',
    owner: '吴恩帅',
  },
  {
    customerNo: 'CUST-1020',
    name: '南方智造集团',
    contact: '孙敏',
    phone: '13677123519',
    owner: '刘洋',
  },
  {
    customerNo: 'CUST-1019',
    name: '博闻会展',
    contact: '何凯',
    phone: '13590440017',
    owner: '王芳',
  },
  {
    customerNo: 'CUST-1018',
    name: '启明公益基金会',
    contact: '林珊',
    phone: '13418862290',
    owner: '刘经理',
  },
  {
    customerNo: 'CUST-1017',
    name: '远景汽车华南区',
    contact: '郑宇',
    phone: '13352916638',
    owner: '刘洋',
  },
  {
    customerNo: 'CUST-1016',
    name: '原野户外俱乐部',
    contact: '宋杰',
    phone: '13266750331',
    owner: '吴恩帅',
  },
  {
    customerNo: 'CUST-1015',
    name: '晨星连锁餐饮',
    contact: '唐妍',
    phone: '13128890326',
    owner: '王芳',
  },
];

export const users = [
  {
    id: 'U-000',
    name: '超级管理员',
    username: 'superadmin',
    department: '总部',
    role: '超级管理员',
    status: '启用',
  },
  {
    id: 'U-001',
    name: '管理员',
    username: 'admin',
    department: '总部',
    role: '管理员',
    status: '启用',
  },
  {
    id: 'U-002',
    name: '刘经理',
    username: 'manager01',
    department: '一店',
    role: '客户部/商务部经理',
    status: '启用',
  },
  {
    id: 'U-003',
    name: '吴恩帅',
    username: 'tracker01',
    department: '一店',
    role: '跟单员',
    status: '启用',
  },
  {
    id: 'U-004',
    name: '刘洋',
    username: 'sales7',
    department: '四店',
    role: '客户部/商务部销售',
    status: '启用',
  },
  {
    id: 'U-005',
    name: '王芳',
    username: 'sales02',
    department: '二店',
    role: '销售',
    status: '启用',
  },
  {
    id: 'U-006',
    name: '陈静',
    username: 'service01',
    department: '三店',
    role: '跟单员',
    status: '启用',
  },
  {
    id: 'U-007',
    name: '赵总',
    username: 'executive',
    department: '总部',
    role: '管理层',
    status: '启用',
  },
  {
    id: 'U-008',
    name: '周航',
    username: 'rental01',
    department: '人人租',
    role: '人人租销售',
    status: '停用',
  },
];

export const optionGroups = {
  客户来源: [
    '老客户转介绍',
    '线上咨询',
    '渠道合作',
    '展会线索',
    '企业微信',
    '市场活动',
    '人人租转介',
  ],
  交付城市: ['深圳', '广州', '上海', '北京', '杭州', '东莞', '珠海', '佛山'],
  付款方式: ['全款', '定金+尾款', '月结', '分期', '现结', '对公转账'],
  服务等级: ['标准', '优先', '驻场', '远程', '7×24 小时', '仅设备'],
};

/** Standalone page fixture only; it is not BusinessCatalog or a formal DTO. */
export const settingsGroups = {
  产品表格字段: [
    '租金',
    '短租价',
    '套餐价/月',
    '分仓库存',
    '折扣',
    '替代设备',
    '备注',
  ],
  推单自定义表单: [
    '客户名称',
    '联系人',
    '联系电话',
    '客户来源',
    '交付城市',
    '报价有效期',
    '服务等级',
  ],
  '部门-公司映射': [
    '一店 → 深圳赛格有限公司',
    '二店 → 乙希贸易有限公司',
    '三店 → 租赁科技有限公司',
    '四店 → 乙希信息技术有限公司',
  ],
};

export const roleOptions = [
  { value: 'super_admin', label: '超级管理员' },
  { value: 'admin', label: '管理员' },
  { value: 'manager', label: '客户经理' },
  { value: 'sales', label: '销售' },
  { value: 'tracker', label: '跟单员' },
  { value: 'exec', label: '管理层' },
  { value: 'ry_sales', label: '人人租销售' },
] as const;

export const formatMoney = (value: number | null | undefined): string =>
  typeof value === 'number' && Number.isFinite(value)
    ? `¥${Math.round(value).toLocaleString('zh-CN')}`
    : '待维护';
